import { useMemo } from 'react'

import AppActionCreators from '../action-creators/AppActionCreators'
import { useComposerSaveMode } from '../components/composer-footer/useComposerSaveMode'
import AppStore from '../stores/AppStore'

const backToOmni = (): void => {
  AppActionCreators.updateOmniboxState(true)
}

export const useBackToOmni = (): {
  backToOmni: () => void
  canGoBackToOmni: boolean
} => {
  // in case it's null the omnibox has not been initialized yet
  const composerMode = useComposerSaveMode()
  const isPreviewMode = AppStore.getIsPreviewMode()

  let canGoBackToOmni =
    AppStore.getIsOmniboxEnabled() === false && composerMode === 'new-post'

  // In preview mode, don't show the back button
  // because there's no actual "Customize" step to go back from
  if (isPreviewMode) {
    canGoBackToOmni = false
  }

  return useMemo(() => ({ backToOmni, canGoBackToOmni }), [canGoBackToOmni])
}
